<ion-card
  *ngIf="bannerStyle === 'allDeals'"
  (click)="traceAllAvailableDeals(buttonLink)"
  class="all-deals"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'tablet'
        : 'mobile'
      : 'desktop'
  "
>
  <div class="all-deals-image"></div>
  <div class="all-deals-container">
    <div class="all-deals-title">
      <span data-cy="all-available-deals-text">
        {{ textOne | translate }}&nbsp;
      </span>
      <span data-cy="all-available-deals-text">{{ textTwo | translate }}</span>
    </div>
    <div data-cy="all-available-deals-subtitle-text" class="all-deals-subtitle">
      {{ textThree | translate }}
    </div>
    <div>
      <!-- Dummy Button, banner is clickable, do not set to click event unless you want to double fire event -->
      <ion-button data-cy="shop-deals-button" class="usf-fill-green-button">
        {{ buttonText | translate }}
      </ion-button>
    </div>
  </div>
</ion-card>

<ion-card
  *ngIf="bannerStyle === 'whileSupplies'"
  (click)="trackWhileSuppliesLast()"
  class="while-supplies"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'tablet'
        : 'mobile'
      : 'desktop'
  "
>
  <div class="supplies-first">
    <span data-cy="while-supplies-last-text">
      {{ textOne | translate }}&nbsp;
    </span>
    <span data-cy="while-supplies-last-text">{{ textFour | translate }}</span>
  </div>
  <div class="supplies-second">
    <div data-cy="while-supplies-last-text">{{ textTwo | translate }}</div>
    <div data-cy="while-supplies-last-text">{{ textThree | translate }}</div>
  </div>
  <div>
    <!-- Dummy Button, banner is clickable, do not set to click event unless you want to double fire event -->
    <ion-button
      data-cy="while-supplies-last-button"
      class="usf-outline-orange-button"
    >
      {{ buttonText | translate }}
    </ion-button>
  </div>
</ion-card>

<ion-card
  *ngIf="bannerStyle === 'scoop'"
  data-cy="scoop-button"
  class="scoop-deals"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'tablet'
        : 'mobile'
      : 'desktop'
  "
  (click)="trackClickScoopBanner()"
>
</ion-card>

<!-- Order submitted with blizzard deals enabled -->
<ng-container *appShowSplit="[globalBlizzardDealsFlag]">
  <ion-card
    observeIntersection
    *ngIf="bannerStyle === 'my-deals'"
    data-cy="my-deals-button"
    class="my-deals my-deals-order-details-deals"
    [ngClass]="
      (platformService?.isTouchExperience$ | async)
        ? platformService?.platformType ===
          platformService?.platformEnum?.tablet
          ? 'tablet'
          : 'mobile'
        : 'desktop'
    "
    [observeAfterLoadedElement]="observeAfterLoadedElement"
    [threshold]="0.75"
    (impression)="bannerOrderDealsView()"
    (click)="bargainsBannerClick()"
  >
  </ion-card>
</ng-container>

<!-- Order submitted with blizzard deals disabled -->
<ng-container *appHideSplit="[globalBlizzardDealsFlag]">
  <ion-card
    observeIntersection
    *ngIf="bannerStyle === 'my-deals'"
    data-cy="my-deals-button"
    class="my-deals my-deals-order-details"
    [ngClass]="
      (platformService?.isTouchExperience$ | async)
        ? platformService?.platformType ===
          platformService?.platformEnum?.tablet
          ? 'tablet'
          : 'mobile'
        : 'desktop'
    "
    [observeAfterLoadedElement]="observeAfterLoadedElement"
    [threshold]="0.75"
    (impression)="bannerOrderDealsView()"
    (click)="bannerOrderDealsClick(buttonLink)"
  >
  </ion-card>
</ng-container>

<ion-card
  observeIntersection
  *ngIf="bannerStyle === 'my-deals-order'"
  data-cy="my-deals-button"
  class="my-deals my-deals-order"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'tablet'
        : 'mobile'
      : 'desktop'
  "
  [observeAfterLoadedElement]="observeAfterLoadedElement"
  [threshold]="0.75"
  (startObservation)="bannerOrderDealsDisplayed()"
  (impression)="bannerOrderDealsView()"
  (click)="bannerOrderDealsClick(buttonLink)"
>
</ion-card>
